/*
 * Tuning of the widget's own global class names inside `StatefulConnectContainer`
 * — hide its message-box title/icon and collapse its header dividers, and let its
 * list/inputs grow. These are descendant selectors that inline styles can't
 * express and the tsc-only build can't take as CSS Modules, so — like the
 * Dialog/Sheet overlay CSS — they are injected once into <head> instead of
 * rendering a `<style>` element per mounted instance.
 */
export const STATEFUL_CONNECT_BODY_CLASS = 'stateful-connect-body';
const STYLE_ELEMENT_ID = 'rango-profile-stateful-connect-styles';
const STATEFUL_CONNECT_CSS = `
.${STATEFUL_CONNECT_BODY_CLASS} ._message_box_description { text-align: left; }
.${STATEFUL_CONNECT_BODY_CLASS} ._message_box_title,
.${STATEFUL_CONNECT_BODY_CLASS} ._message_box_icon_container,
.${STATEFUL_CONNECT_BODY_CLASS} ._initial_namespace_list_header_alert_top_divider,
.${STATEFUL_CONNECT_BODY_CLASS} ._detached_namespace_list_header_alert_top_divider { display: none; }
.${STATEFUL_CONNECT_BODY_CLASS} ul,
.${STATEFUL_CONNECT_BODY_CLASS} ._derivation_path_inputs_container { flex-grow: 1; }
.${STATEFUL_CONNECT_BODY_CLASS} ._initial_namespace_list_header_alert_bottom_divider,
.${STATEFUL_CONNECT_BODY_CLASS} ._initial_namespace_list_header_button_top_divider,
.${STATEFUL_CONNECT_BODY_CLASS} ._initial_namespace_list_header_button_bottom_divider,
.${STATEFUL_CONNECT_BODY_CLASS} ._detached_namespace_list_header_alert_bottom_divider,
.${STATEFUL_CONNECT_BODY_CLASS} ._detached_namespace_list_header_button_top_divider,
.${STATEFUL_CONNECT_BODY_CLASS} ._detached_namespace_list_header_button_bottom_divider { height: 0; }
`;
/** Inject the stateful-connect tuning stylesheet into <head> once (idempotent, client-only). */
export function ensureStatefulConnectStyles() {
    if (typeof document === 'undefined' || document.getElementById(STYLE_ELEMENT_ID)) {
        return;
    }
    const style = document.createElement('style');
    style.id = STYLE_ELEMENT_ID;
    style.textContent = STATEFUL_CONNECT_CSS;
    document.head.appendChild(style);
}
